/* eslint-disable max-len */
import { client } from '../../../../../../common-utils/libraries/axios/axios';
import PAYLUDD_SUBSCRIPTIONS from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';
import payluddSubscriptionFields from '../../fields/payluddSubscriptionFields';

/**
 * @param responseData response.data object
 * @param responseData.items array of payludd subscription items
 * @param responseData.totalResults number
 * @returns Mapped data object with items and totalResults
 */
function mapResponseData(responseData) {
    const data = {};

    const mappedItems = responseData.contractProfiles.map(item => {
        return {
            [payluddSubscriptionFields.CONTRACT.PROFILES.UUID.key]: item[payluddSubscriptionFields.CONTRACT.PROFILES.UUID.key],
            [payluddSubscriptionFields.CONTRACT.PROFILES.APPLICATION.key]: item[payluddSubscriptionFields.CONTRACT.PROFILES.APPLICATION.key],
            [payluddSubscriptionFields.CONTRACT.PROFILES.NUMBER.key]: item[payluddSubscriptionFields.CONTRACT.PROFILES.NUMBER.key],
            [payluddSubscriptionFields.CONTRACT.PROFILES.BANK_CODE.key]: item[payluddSubscriptionFields.CONTRACT.PROFILES.BANK_CODE.key],
            [payluddSubscriptionFields.CONTRACT.PROFILES.RANK.key]: item[payluddSubscriptionFields.CONTRACT.PROFILES.RANK.key],
            [payluddSubscriptionFields.CONTRACT.PROFILES.LABEL.key]: item[payluddSubscriptionFields.CONTRACT.PROFILES.LABEL.key]
        };
    });

    data[payluddSubscriptionFields.CONTRACT.CREATED_AT.key] = responseData[payluddSubscriptionFields.CONTRACT.CREATED_AT.key];
    data[payluddSubscriptionFields.CONTRACT.UPDATED_AT.key] = responseData[payluddSubscriptionFields.CONTRACT.UPDATED_AT.key];
    data[payluddSubscriptionFields.CONTRACT.UUID.key] = responseData[payluddSubscriptionFields.CONTRACT.UUID.key];
    data[payluddSubscriptionFields.CONTRACT.LABEL.key] = responseData[payluddSubscriptionFields.CONTRACT.LABEL.key];
    data[payluddSubscriptionFields.CONTRACT.PROVIDER.key] = responseData[payluddSubscriptionFields.CONTRACT.PROVIDER.key];

    data.items = mappedItems;
    data.totalResults = responseData.contractProfiles.length ?? 0;

    return data;
}

const queryGetMerchantAccountPayluddSubscriptions = ({ posTerminalId }) => {
    return {
        queryKey: [PAYLUDD_SUBSCRIPTIONS.EMERGENCY_REMOTE_COLLECTION_CONTRACTS.queryKey, posTerminalId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(PAYLUDD_SUBSCRIPTIONS.EMERGENCY_REMOTE_COLLECTION_CONTRACTS.url, { uuid: posTerminalId }));
            return mapResponseData(response.data);
        }
    };
};


export default queryGetMerchantAccountPayluddSubscriptions;